<template>
  <div class="shake-game">
    <div class="main-title">使用帮助/互动游戏/摇一摇游戏</div>
    <h1 class="page-title">摇一摇游戏</h1>
    <h4 class="content-text">
      通过手机摇一摇来比拼手速，最终展示总排名的互动游戏。
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-shakeGame1_176829111539434d2e1.webp"
      alt="酒吧大屏互动摇一摇赛车游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （都市赛车）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-shakeGame2_17682911153941559bf.webp"
      alt="酒吧大屏互动摇一摇猴子爬树游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （猴子爬树）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-shakeGame3_1768291115394bd88fc.webp"
      alt="酒吧大屏互动摇一摇疯狂游泳游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （疯狂游泳）
    </h4>
    <img
      src="https://ustatic.hudongmiao.com/miao/common/help-shakeGame4_1768291115394fd3770.webp"
      alt="酒吧大屏互动摇一摇谁最牛游戏"
      class="example-image"
    />
    <h4 class="content-text center">
      （谁最牛）
    </h4>
  </div>
</template>

<script>
export default {
  name: 'ShakeGame',
};
</script>

<style lang="less" scoped>
.shake-game {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.main-title {
  width: 100%;
  font-weight: 500;
  font-size: 20px;
  color: #E19BFF;
  text-align: left;
  margin-top: 10px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E19BFF;
}

.page-title {
  width: 100%;
  font-weight: 700;
  font-size: 32px;
  color: #FFFFFF;
  text-align: left;
  margin-top: 10px;
}

.content-text {
  width: 100%;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
  text-align: left;
  word-wrap: break-word;
  word-break: break-all;
  margin-top: 10px;
}

.example-image {
  width: 100%;
  height: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}

.center {
  text-align: center;
  margin-top: 0;
}
</style>
